import { Location, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useEffect } from 'react'

import { MatchedRoute, findCurrentRoute } from '../utils/routes'

import { useAppConfig } from './useAppConfig'

export function useCurrentRoute(): {
  route: MatchedRoute | null
  location: Location
} {
  const location = useLocation()
  const { routes } = useAppConfig()
  const { t, i18n } = useTranslation(['routes'])
  const [route, setRoute] = useState<MatchedRoute | null>(findCurrentRoute(routes, location.pathname, t, i18n.language))

  useEffect(() => {
    setRoute(findCurrentRoute(routes, location.pathname, t, i18n.language))
  }, [i18n.language, location, location.pathname, routes, t])

  return {
    route: route,
    location: location
  }
}
